import type { Member } from "common/types";

import LoginLink from "../LoginLink";
import RemoveMember from "../RemoveMember";
import UpdatePermissions from "../UpdatePermissions";

import type { CLIENT_ACTIONS } from "../../constants";

interface ClientActionsProps {
  member: Member;
  action: keyof typeof CLIENT_ACTIONS;
  onClose: () => void;
  onBack: () => void;
}

export default function ClientActions({
  member,
  action,
  onClose,
  onBack,
}: ClientActionsProps) {
  if (action === "remove") {
    const { email, customer_id } = member;
    return (
      <RemoveMember
        email={email}
        memberCustomerId={customer_id}
        onBack={onBack}
      />
    );
  }

  if (action === "permissions") {
    return (
      <UpdatePermissions member={member} onClose={onClose} onBack={onBack} />
    );
  }

  if (action === "loginLink") {
    return <LoginLink member={member} onBack={onBack} />;
  }
}
